<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Molecule"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="headline font-weight-medium text-center mt-8" :class="colorTitle">
            <div v-if="front=='process'">
                Molecule Building Process
            </div>
            <div v-if="front=='animation'">
                Molecule
            </div>
        </div>

        <div class="text-center" v-if="front=='process'">
            <div class="body-2 grey--text text--darken-2" v-if="completed">The data is complete.</div>
            <div class="body-2 grey--text text--darken-2" v-else>Go through the steps to complete all the data needed.</div>
        </div>

        <div class="text-center" v-if="front=='animation'">
            <div class="body-2 grey--text text--darken-2">Navigate through your molecule.</div>
        </div>

        <div class="text-center mt-4" v-if="completed">
            <v-btn class="mr-1" :class="(front=='process') ? 'success' : 'accent'" @click="front='process'" v-if="front=='animation'">
                <v-icon small left color="white">fa-wrench</v-icon>
                <span class="mr-1" v-if="front=='animation'">Go to</span>
                <span>Building process</span>
            </v-btn>
            <v-btn class="ml-1 success" @click="front='animation'" v-if="front=='process'">
                <v-icon small left color="white">fa-atom</v-icon>
                Go to your Molecule
            </v-btn>
        </div>

        <v-divider class="mt-6" v-show="front=='animation'"></v-divider>

        <template v-if="front=='process'">
            <BuildingProcess @pestain="setPestain" />
        </template>

        <div v-show="front=='animation'">
            <div class="d-flex justify-center mt-6">
                <v-btn class="bMolecule white--text mx-1" @click="zoomIn" :disabled="zoomin">
                    <v-icon small color="white" left>fa-search-plus</v-icon>
                    Zoom in
                </v-btn>
                <v-btn class="bMolecule white--text mx-1" @click="zoomOut" :disabled="!zoomin">
                    <v-icon small color="white" left>fa-search-plus</v-icon>
                    Zoom out
                </v-btn>
            </div>

            <div class="d-flex justify-center pb-4" style="margin-top:80px">
                <div ref="central" class="central">
                    <Central :photo="user.photo" :name="user.name" :attributes="user.attributes" />
                </div>
                <div ref="extended" class="extended">
                    <Extended :concepts="user.concepts" />
                </div>
            </div>
        </div>

	</v-card>
</template>

<script>
import { gsap } from 'gsap'
import Helpers from '@/services/helpers'
import BuildingProcess from '@/components/molecule/BuildingProcess'
import Central from '@/components/molecule/Central'
import Extended from '@/components/molecule/Extended'

export default {
    data: () => ({
        front: 'process',
        pestain: 1,
        zoomin: false,
        esta: null
    }),
    components: {
        BuildingProcess,
        Central,
        Extended
    },
    computed: {
        colorTitle() {
            if (this.pestain == 1) return 'bMolecule--text';
            if (this.pestain == 2) return 'cyan--text text--accent-4';
        },
        completed() {
            if (this.user.attributes && this.user.concepts && this.user.concepts.feeling && this.user.concepts.interestedIn && this.user.concepts.goodAt) {
                return true;
            }
            return false;
        }
    },
    mounted() {
        //this.esta = gsap.timeline();
        //this.appear();
    },
    methods: {
        setPestain(e) {
            this.pestain = e;
        },
        // appear() {
        //     this.esta.fromTo(this.$refs['central'], 1.8,{ webkitFilter: "brightness(1)", filter: "brightness(1)" },
        //             {
        //                 webkitFilter: "brightness(1.5)",
        //                 filter: "brightness(1.5)",
        //                 yoyo: true,
        //                 repeat: -1,
        //                 repeatDelay: 1.5,
        //                 ease:'Linear.easeNone'
        //             }
        //         );
        // },
        zoomIn() {
            gsap.timeline().paused();
            gsap.fromTo(this.$refs['central'], {opacity:1 }, {y:-12, x:-12, scaleX: .4, scaleY: .4, duration:1.2, ease:'circ.out' });
            gsap.fromTo(this.$refs['extended'], {opacity:0 }, {opacity:1, duration:1.2, delay:.6, ease:'circ.out' });
            this.zoomin = true;
            // this.esta.pause();
        },
        zoomOut() {
            gsap.fromTo(this.$refs['central'], {opacity:1 }, {y:-12, x:-12, scaleX: 1, scaleY: 1, duration:1.2, delay:.4, ease:'circ.out' });
            gsap.fromTo(this.$refs['extended'], {opacity:1 }, {opacity:0, duration:1.2, ease:'circ.out' });
            this.zoomin = false;
            // setTimeout(() => {
            //     this.esta.resume();
            // }, 1000);
        }
    }
}
</script>

<style scoped>
    .central {
        position:relative;
        left:300px;
    }

    .extended {
        position:relative;
        opacity: 0;
        left:-290px;
        top:-51px;
    }
</style>

